import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _defaultProps;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: ", ";\n\n  input:required {\n    box-shadow: none;\n  }\n  max-width: ", ";\n  min-width: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import cuid from 'cuid';
import { calculateRem } from '@uie/javascript-style-helpers';
import UNSAFE_SetEnvRef from '@uie/set-env-ref';
import { InputField } from '../InputField';
import Icon, { IconData } from '@vds-core/icons';
import DefaultCalendar from './Calendar';
import formatDate from './formatDate';
import { breakpoints, verizonTheme as colors, calculateSpacing } from '@vds-core/theme';
import { Micro, Body, BodyConfig, TypographyConfig } from '@vds-core/typography';
import { withVDSManager } from '@vds-core/utilities';
var propTypes = {
  /**
   * The beginning of a period that shall be displayed by the Calendar. If no value is provided, the current date (<code>new Date()</code>) will be used.
   */
  selectedDate: PropTypes.instanceOf(Date),

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If true, the calendar input will be rendered in an Error state.
   */
  error: PropTypes.bool,

  /**
   * @deprecated
   * The size of the DatePicker input field.
   */
  size: PropTypes.oneOf(['normal', 'small', 'large']),

  /**
   * Callback used to get the selected date from DatePicker.
   */
  onChange: PropTypes.func,

  /**
   * If provided and in error state, the error text will be displayed under the calendar input.
   */
  errorText: PropTypes.string,

  /**
   * If provided, this will render as the label text of the DatePicker input.
   */
  label: PropTypes.string,

  /**
   * @ignore
   */
  readOnly: PropTypes.bool,

  /**
   * If provided, the Input will be rendered in the Disabled State.
   */
  disabled: PropTypes.bool,

  /**
   * If provided, will override the default sizing widths for the small and large datepicker input.
   */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * The format of the DatePicker field, can be 'MM/DD/YY' or 'Month, Date, Year'.
   */
  format: PropTypes.oneOf(['MM/DD/YY', 'Month, Date, Year']),

  /**
   * @deprecated
   * The beginning of a period that shall be displayed by the Calendar. If no value is provided, the current date (<code>new Date()</code>) will be used.
   */
  activeStartDate: PropTypes.instanceOf(Date),

  /**
   * @deprecated
   * Callback used to get the selected date from DatePicker.
   */
  handleDatePick: PropTypes.func,

  /**
   * @ignore
   */
  required: PropTypes.bool,

  /**
   * @ignore - config for passing through other colors
   */
  colorConfig: PropTypes.object,

  /**
   * @ignore - config for passing though typography
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore - passes through typescale via sting if there's more than one option [example 'VDS' instead of 'MVP']
   */
  typescale: PropTypes.string,

  /**
   * @ignore - used for state in showing and hiding error icon on focus of the input
   */
  iconFocusState: PropTypes.bool,

  /**
   * @ignore - passes Icon data through
   */
  iconConfig: PropTypes.object,

  /**
   * @ignore - moves icon to the right side of the input label
   */
  iconPosition: PropTypes.string,

  /**
   * @ignore - adds max-width to input field
   */
  maxWidth: PropTypes.string,

  /**
   * @ignore - adds min-width to input field
   */
  minWidth: PropTypes.string,

  /**
   * @ignore - adds hover state to input field
   */
  hoverState: PropTypes.bool,

  /**
   * @ignore - padding on the inside of the input field takes in params of iconFocusState and error
   */
  calculateInputPadding: PropTypes.func,

  /**
   * @ignore - spacing between the label and the input field
   */
  labelMarginBottom: PropTypes.string,

  /**
   * @ignore - defines whether text trancates with ellipsis or not
   */
  overflowEllipsis: PropTypes.bool,

  /**
   * @ignore
   */
  readOnlyBorders: PropTypes.bool,

  /**
   * @ignore
   */
  Calendar: PropTypes.func,

  /**
   * If provided, the calendar will allow a selection to be made from this date forward. Defaults to today.
   */
  minDate: PropTypes.instanceOf(Date),

  /**
   * If provided, dates will be selectable up until this date.
   */
  maxDate: PropTypes.instanceOf(Date),

  /**
   * @deprecated
   * Replaced with minDate prop.
   */
  pastDatesDisabled: PropTypes.bool,

  /**
   * @ignore - number representing height of input field
   */
  inputHeight: PropTypes.string,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string,

  /**
   * Allows a unique ID to be passed to the input element.
   */
  inputId: PropTypes.string,

  /**
   * @ignore If passed, the Tooltip will render
   */
  Tooltip: PropTypes.func,

  /**
   * Enable specific days. Pass an array of string elements of date format e.g. ['07/21/2020', '07/24/2020', '07/28/2020'].  All other dates will be inactive.
   */
  activeDates: PropTypes.array,

  /**
   * Disable specific days. Pass an array of string elements of date format e.g. ['07/21/2020', '07/24/2020', '07/28/2020'].  All other dates will be active.
   */
  inactiveDates: PropTypes.array
};
var defaultProps = (_defaultProps = {
  className: null,
  error: false,
  size: 'normal',
  onChange: function onChange() {},
  errorText: 'Error Text',
  label: '',
  disabled: false,
  readOnly: false,
  width: '100%',
  format: 'Month, Date, Year',
  inputHeight: calculateRem(42),
  pastDatesDisabled: true,
  minDate: new Date(),
  maxDate: undefined,
  colorConfig: colors,
  typescale: TypographyConfig.getTypescale(),
  inactiveDates: null,
  activeDates: null,
  Calendar: DefaultCalendar
}, _defineProperty(_defaultProps, "pastDatesDisabled", false), _defineProperty(_defaultProps, "Tooltip", undefined), _defaultProps);
var DatePickerContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "DatePickerContainer",
  componentId: "rpyx36-0"
})(_templateObject(), function (_ref) {
  var width = _ref.width;
  return width ? typeof width === 'number' ? calculateRem(width) : width : calculateRem(136);
}, function (_ref2) {
  var maxWidth = _ref2.maxWidth;
  return calculateRem(maxWidth);
}, function (_ref3) {
  var minWidth = _ref3.minWidth;
  return calculateRem(minWidth);
});

var DatePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  var _super = _createSuper(DatePicker);

  function DatePicker(props) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "refKey", UNSAFE_SetEnvRef());

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var format = _this.props.format;

      if (_this.props.activeStartDate || _this.props.selectedDate) {
        _this.setState({
          date: formatDate(_this.props.activeStartDate || _this.props.selectedDate, format === 'MM/DD/YY')
        });
      }

      document.addEventListener('mousedown', _this.handleClickOutside);
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      document.removeEventListener('mousedown', _this.handleClickOutside);
    });

    _defineProperty(_assertThisInitialized(_this), "closeCalendar", function () {
      _this.setState({
        isOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openCalendar", function () {
      _this.setState({
        isOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (e) {
      if (_this.calendarRef && !_this.calendarRef.contains(e.target)) {
        if (_this.state.isOpen) {
          _this.closeCalendar();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (date) {
      var _this$props = _this.props,
          size = _this$props.size,
          format = _this$props.format;
      var shortDate = format !== 'Month, Date, Year' || size === 'small';
      var formattedDate = formatDate(date, shortDate);

      _this.setState({
        date: formattedDate
      });

      if (typeof _this.props.handleDatePick !== 'undefined') _this.props.handleDatePick(formattedDate);

      _this.props.onChange(formattedDate);

      _this.closeCalendar();
    });

    _this.state = {
      isOpen: _this.props.isOpen ? _this.props.isOpen : false
    };
    return _this;
  }

  _createClass(DatePicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          size = _this$props2.size,
          format = _this$props2.format,
          selectedDate = _this$props2.selectedDate;
      var shortDate = format !== 'Month, Date, Year';

      if (size !== prevProps.size || format !== prevProps.format) {
        var formattedDate = formatDate(this.state.date, shortDate);
        this.setState({
          date: formattedDate
        });
      } else if (selectedDate !== prevProps.selectedDate) {
        var _formattedDate = formatDate(selectedDate, shortDate);

        this.setState({
          date: _formattedDate
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          selectedDateProp = _this$props3.selectedDate,
          onChange = _this$props3.onChange,
          activeStartDate = _this$props3.activeStartDate,
          className = _this$props3.className,
          errorText = _this$props3.errorText,
          label = _this$props3.label,
          error = _this$props3.error,
          size = _this$props3.size,
          readOnly = _this$props3.readOnly,
          disabled = _this$props3.disabled,
          widthProp = _this$props3.width,
          format = _this$props3.format,
          bodyConfig = _this$props3.bodyConfig,
          typescale = _this$props3.typescale,
          hoverState = _this$props3.hoverState,
          readOnlyBorders = _this$props3.readOnlyBorders,
          overflowEllipsis = _this$props3.overflowEllipsis,
          calculateInputPadding = _this$props3.calculateInputPadding,
          minWidth = _this$props3.minWidth,
          maxWidth = _this$props3.maxWidth,
          iconConfig = _this$props3.iconConfig,
          labelMarginBottom = _this$props3.labelMarginBottom,
          iconPosition = _this$props3.iconPosition,
          colorConfig = _this$props3.colorConfig,
          required = _this$props3.required,
          focusState = _this$props3.focusState,
          placeHolderText = _this$props3.placeHolderText,
          styleConfig = _this$props3.styleConfig,
          Calendar = _this$props3.Calendar,
          minDate = _this$props3.minDate,
          maxDate = _this$props3.maxDate,
          pastDatesDisabled = _this$props3.pastDatesDisabled,
          tooltipTitle = _this$props3.tooltipTitle,
          tooltipContent = _this$props3.tooltipContent,
          Tooltip = _this$props3.Tooltip,
          inactiveDates = _this$props3.inactiveDates,
          activeDates = _this$props3.activeDates,
          id = _this$props3.id,
          helperText = _this$props3.helperText,
          helperTextPlacement = _this$props3.helperTextPlacement,
          Body = _this$props3.Body,
          Micro = _this$props3.Micro,
          inputId = _this$props3.inputId,
          otherProps = _objectWithoutProperties(_this$props3, ["selectedDate", "onChange", "activeStartDate", "className", "errorText", "label", "error", "size", "readOnly", "disabled", "width", "format", "bodyConfig", "typescale", "hoverState", "readOnlyBorders", "overflowEllipsis", "calculateInputPadding", "minWidth", "maxWidth", "iconConfig", "labelMarginBottom", "iconPosition", "colorConfig", "required", "focusState", "placeHolderText", "styleConfig", "Calendar", "minDate", "maxDate", "pastDatesDisabled", "tooltipTitle", "tooltipContent", "Tooltip", "inactiveDates", "activeDates", "id", "helperText", "helperTextPlacement", "Body", "Micro", "inputId"]);

      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          date = _this$state.date;
      var dateId = inputId ? inputId : cuid();
      var selectedDate = error ? null : activeStartDate ? activeStartDate : selectedDateProp || date;
      var iconColor = colorConfig.black;

      if (this.props.disabled) {
        iconColor = colorConfig.grayLight;
      } else if (!date && typescale !== 'VDS') {
        iconColor = colorConfig.coolGray6;
      }

      var width = widthProp ? widthProp : size === 'normal' || size === 'large' ? 288 : 136;
      return /*#__PURE__*/React.createElement(DatePickerContainer, _extends({
        id: id,
        className: className,
        width: width,
        styleConfig: styleConfig,
        minWidth: minWidth,
        maxWidth: maxWidth
      }, _defineProperty({}, this.refKey, function (elem) {
        return _this2.calendarRef = elem;
      })), /*#__PURE__*/React.createElement(InputField, _extends({
        calendarIconColor: iconColor,
        overflowEllipsis: overflowEllipsis,
        focusState: focusState,
        iconPosition: iconPosition,
        required: required,
        minWidth: minWidth,
        maxWidth: maxWidth,
        typescale: typescale,
        iconConfig: iconConfig,
        hoverState: hoverState,
        bodyConfig: bodyConfig,
        readOnlyBorders: readOnlyBorders,
        labelMarginBottom: labelMarginBottom,
        calculateInputPadding: calculateInputPadding,
        color: colorConfig,
        width: width,
        label: label,
        disabled: disabled,
        readOnly: readOnly,
        error: error,
        errorText: errorText,
        onClick: readOnly ? function () {} : this.openCalendar,
        onKeyUp: readOnly ? function () {} : this.openCalendar,
        placeholder: 'Select Date',
        pickerSize: size,
        value: date || '',
        isOpen: isOpen,
        autoComplete: "off",
        Tooltip: Tooltip,
        tooltipTitle: tooltipTitle,
        tooltipContent: tooltipContent,
        helperText: helperText,
        helperTextPlacement: helperTextPlacement,
        Body: Body,
        Micro: Micro,
        inputId: dateId
      }, otherProps, {
        type: "calendar"
      })), /*#__PURE__*/React.createElement(Calendar, {
        Calendar: Calendar,
        selectedDate: selectedDate,
        isOpen: isOpen,
        onChange: this.onChange,
        minDate: minDate,
        maxDate: maxDate,
        pastDatesDisabled: pastDatesDisabled,
        inactiveDates: inactiveDates,
        activeDates: activeDates
      }));
    }
  }]);

  return DatePicker;
}(React.Component);

DatePicker.propTypes = propTypes;
DatePicker.defaultProps = defaultProps;
export default withVDSManager(DatePicker);